import { checkJsonProp, translationGroups } from "@utilities";
import { Notification } from "@components";

export const serverErrorsMiddleware = store => next => action => {
  const { type } = action,
    matches = /(.*)_(ERROR)/.exec(type);

  let result = next(action),
    test = store.getState();
  if (!matches) {
    return result;
  }

  if (result?.error?.response?.status === 401) {
    localStorage.clear();
    sessionStorage.clear();

    Notification({
      type: "error",
      message: translationGroups.ErrorCode + "AuthErrors"
    });

    return;
  }

  for (let key in test) {
    let error = checkJsonProp(test[key], "errors");
    if (error !== null && error !== "") {
      let errorValues = checkJsonProp(error, "response.data.message"),
        errorCode = checkJsonProp(error, "response.data.errorCode");
      if (errorValues === null) errorValues = error.message;
      if (errorCode === null) errorCode = "Unknown error";

      Notification({
        type: "error",
        message: translationGroups.ErrorCode + errorCode,
        description: errorValues,
        noTranslateDescription: true
      });
    }
  }

  return result;
};
